/**
 * Training phases — list view. Phase editing lands when the Health agent's
 * planning UI matures; for now you can see what's there and use the API.
 */

import { useTrainingPhases } from '../../api/health';
import styles from './health.module.css';

export function HealthPhasesScreen() {
  const phases = useTrainingPhases();

  return (
    <div className={styles.page}>
      <header className={styles.head}>
        <div>
          <h2 className={styles.title}>Training phases</h2>
          <div className={styles.subtitle}>
            Stretches of training with a primary goal. Phases are created by
            the Fitness Agent based on your profile + goals + availability.
            Posting at <code>POST /api/apps/health/phases</code> works today.
          </div>
        </div>
      </header>

      {phases.isLoading ? (
        <div className={styles.muted}>Loading…</div>
      ) : (phases.data?.phases ?? []).length === 0 ? (
        <div className={styles.empty}>
          No phases yet. Create one via the API or wait for the Fitness Agent.
        </div>
      ) : (
        <div className={styles.list}>
          {(phases.data?.phases ?? []).map((p) => (
            <div key={p.id} className={styles.row}>
              <div className={styles.rowMain}>
                <div className={styles.rowTitle}>{p.name}</div>
                <div className={styles.rowMeta}>
                  {p.startDate ?? '—'} → {p.endDate ?? '—'}
                  {p.weeks ? ` · ${p.weeks} weeks` : ''}
                  {p.primaryGoal ? ` · ${p.primaryGoal}` : ''}
                </div>
              </div>
              <span className={styles.tag}>{p.status}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
